(function() {
    var formContainers = document.querySelectorAll('div[data-sf-role="form-container"]');

    if (formContainers) {
        console.log("We have form containers!");
        var i, requiredIndicator, requiredText;

        requiredIndicator = document.createElement("SPAN"); 
        requiredIndicator.className = "required-field";
        requiredText = document.createTextNode("*");
        requiredIndicator.appendChild(requiredText);  
        //var reqStyles = '<span style="color:red;font-family:Verdana,Arial,Helvetica,sans-serif">*</span>';

        for (i = 0; i < formContainers.length; i++) {
            var eInputs, eTextAreas, eSelects, eRadios, eCheckboxes, w, x, y, z, a;

            // Inputs
            eInputs = formContainers[i].querySelectorAll('input[required]');
            if (eInputs) {
                for (w = 0; w < eInputs.length; w++) {
                    console.log("We have Inputs!");
                    var eInputLabel = eInputs[w].previousElementSibling;
                    if (eInputLabel && eInputLabel.tagName == 'LABEL') {
                        eInputLabel.className = "required-field-label";
                    }
                }
            }

            // TextAreas
            eTextAreas = formContainers[i].querySelectorAll('textarea[required]');
            if (eTextAreas) {
                for (x = 0; x < eTextAreas.length; x++) {
                    console.log("We have TextAreas!");
                    var eTextAreaLabel = eInputs[x].previousElementSibling;
                    if (eTextAreaLabel && eTextAreaLabel.tagName == 'LABEL') {
                        eTextAreaLabel.className = "required-field-label";
                    }
                }
            }

            // Selects
            eSelects = formContainers[i].querySelectorAll('select[required]');
            if (eSelects) {
                for (y = 0; y < eSelects.length; y++) {
                    console.log("We have Selects!");
                    var eSelectLabel = eInputs[y].previousElementSibling;
                    if (eSelectLabel && eSelectLabel.tagName == 'LABEL') {
                        eSelectLabel.className = "required-field-label";
                    }
                }
            }

            // Radios
            eRadios = formContainers[i].querySelectorAll('div[data-sf-role="multiple-choice-field-container"]');
            if (eRadios) {
                for (z = 0; z < eRadios.length; z++) {
                    console.log("We have Radios!");
                    var isRequiredMsg = eRadios[z].querySelectorAll('input[data-sf-role="violation-messages"]')[0];
                    if (isRequiredMsg) {
                        console.log("We have REQUIRED Radios!");
                        var eRadioListLabel = isRequiredMsg.nextElementSibling;
                        if (eRadioListLabel && (eRadioListLabel.tagName == 'STRONG' || eRadioListLabel.tagName == 'P')) {
                            eRadioListLabel.className = "required-field-label";
                        }
                    }
                }
            }

            // Checkboxes
            eCheckboxes = formContainers[i].querySelectorAll('div[data-sf-role="checkboxes-field-container"]');
            if (eCheckboxes) {
                for (a = 0; a < eCheckboxes.length; a++) {
                    console.log("We have Checkboxes!");
                    var isRequiredVal = eCheckboxes[a].querySelectorAll('input[data-sf-role="required-validator"]')[0];
                    if (isRequiredVal) {
                        console.log("We have REQUIRED Checkboxes!");
                        var eCheckboxListLabel = isRequiredVal.nextElementSibling;
                        if (eCheckboxListLabel && (eCheckboxListLabel.tagName == 'STRONG' || eCheckboxListLabel.tagName == 'P')) {
                            eCheckboxListLabel.className = "required-field-label";
                        }
                    }
                }
            }

        }
    }
})();